// src/frontend/data/books/BlockchainFundamentals/data/cap7.js

const CAP8 = {
  id: 7,
  slug: "cap7-iota",
  title: "Capítulo 7 — IOTA: DLT, Tangle y el Internet de las Cosas (IoT)",
  sections: [
    {
      heading: "¿Qué es IOTA?",
      text: [
        "IOTA es un proyecto de tecnología Distributed Ledger Technology (DLT) diseñado para llevar la descentralización al Internet de las Cosas (IoT).",
        "A diferencia de la mayoría de las criptomonedas, IOTA no utiliza una blockchain tradicional, sino una estructura basada en grafos acíclicos dirigidos (DAG).",
        "Su objetivo es permitir interacciones seguras, escalables y sin comisiones entre dispositivos conectados a Internet."
      ]
    },
    {
      heading: "IOTA y el Internet de las Cosas (IoT)",
      text: [
        "El Internet de las Cosas conecta dispositivos cotidianos como teléfonos, tarjetas NFC, electrodomésticos, sensores industriales, cámaras y vehículos.",
        "IOTA busca crear una red donde estos dispositivos puedan intercambiar datos, valor y mensajes de forma autónoma.",
        "Esta visión apunta a una economía máquina-a-máquina (M2M) descentralizada."
      ]
    },
    {
      heading: "Origen del proyecto IOTA",
      text: [
        "IOTA fue creado por David Sønstebø, Dominik Schiener, Sergey Ivancheglo y Serguei Popov.",
        "El primer whitepaper fue publicado el 3 de abril de 2016.",
        "El desarrollo inicial fue financiado mediante una ICO que recaudó aproximadamente 1.300 BTC.",
        "El suministro total de tokens fue distribuido proporcionalmente entre los participantes iniciales."
      ]
    },
    {
      heading: "DLT y DAG: por qué IOTA no es una blockchain",
      text: [
        "IOTA no utiliza bloques ni cadenas de bloques.",
        "En su lugar, emplea una estructura DAG llamada Tangle.",
        "Esto elimina conceptos tradicionales como bloques, mineros y comisiones por transacción."
      ]
    },
    {
      heading: "¿Qué es Tangle?",
      text: [
        "Tangle es la estructura de datos central de IOTA.",
        "Está basada en grafos acíclicos dirigidos (DAG).",
        "Cada transacción confirma dos transacciones anteriores, creando una red de validaciones interconectadas."
      ]
    },
    {
      heading: "Cómo funciona el consenso en IOTA",
      text: [
        "En IOTA no existen mineros.",
        "Cada usuario que emite una transacción debe validar dos transacciones previas.",
        "Esto distribuye el consenso entre todos los participantes de la red.",
        "Cuantas más transacciones validan una transacción, mayor es su nivel de consenso."
      ]
    },
    {
      heading: "Sitios y nodos en Tangle",
      list: [
        "Sitios: transacciones representadas como vértices en el DAG.",
        "Nodos: participantes que emiten y validan transacciones.",
        "Cada nodo cumple funciones básicas sin requerir alto poder computacional."
      ]
    },
    {
      heading: "Escalabilidad y ausencia de comisiones",
      text: [
        "En IOTA no existen comisiones por transacción.",
        "El spam no debilita la red, sino que contribuye a validar transacciones.",
        "La ausencia de bloques elimina cuellos de botella.",
        "Esto permite baja latencia y escalabilidad teórica superior a las blockchains tradicionales."
      ]
    },
    {
      heading: "Tolerancia al particionado",
      text: [
        "A diferencia de blockchains tradicionales, IOTA tolera fragmentaciones temporales de red.",
        "Las particiones pueden separarse y luego volver a integrarse sin generar forks incompatibles.",
        "Esto es especialmente útil en entornos IoT con conectividad intermitente."
      ]
    },
    {
      heading: "El Coordinador",
      text: [
        "Durante sus primeras etapas, IOTA utilizó una entidad llamada Coordinador.",
        "El Coordinador emitía hitos para proteger la red contra ataques como el doble gasto.",
        "Aunque mejoraba la seguridad inicial, introducía un elemento centralizado."
      ]
    },
    {
      heading: "Coordicide: eliminación del Coordinador",
      text: [
        "El Coordicide es el proceso mediante el cual IOTA busca eliminar completamente el Coordinador.",
        "El objetivo es lograr una red completamente descentralizada.",
        "Todos los nodos participarían en igualdad de condiciones en el consenso.",
        "Este paso representaría un hito sin precedentes en DLT."
      ]
    },
    {
      heading: "Rendimiento y pruebas de escalabilidad",
      text: [
        "En pruebas de 2017, IOTA logró procesar más de 112 transacciones por segundo con 250 nodos.",
        "En condiciones ideales, se estima que la red podría manejar más de 1.000 TPS.",
        "El rendimiento aumenta conforme crece la red."
      ]
    },
    {
      heading: "Criptografía y firmas",
      text: [
        "IOTA utiliza el algoritmo de firma EdDSA.",
        "Ofrece firmas pequeñas, eficiencia y resistencia a canales laterales.",
        "Anteriormente se usó Curl-P-27, pero fue reemplazado por Kerl (basado en SHA-3)."
      ]
    },
    {
      heading: "Problemas de seguridad históricos",
      text: [
        "IOTA ha enfrentado críticas por vulnerabilidades de seguridad en sus primeras etapas.",
        "Se detectaron problemas en funciones hash, generación de semillas y wallets.",
        "Estos eventos provocaron pérdidas de fondos y cuestionamientos a la gestión del proyecto."
      ]
    },
    {
      heading: "Incidentes relevantes",
      list: [
        "Rotura de Curl-P-27 y migración a Kerl.",
        "Ataque 13/M que expuso claves privadas.",
        "Estafa de generadores de semillas en 2018.",
        "Ataque a la wallet Trinity en 2019-2020 que detuvo la red por 11 días."
      ]
    },
    {
      heading: "Shimmer Network: red canaria de IOTA",
      text: [
        "Shimmer Network fue lanzada en septiembre de 2022.",
        "Funciona como red experimental para probar nuevas funciones.",
        "Incluye smart contracts Turing-completos, compatibilidad EVM y WASM.",
        "Permite desarrollar DApps, NFTs y tokens antes de su despliegue en IOTA."
      ]
    },
    {
      heading: "La Fundación IOTA",
      text: [
        "La Fundación IOTA es una organización sin fines de lucro con sede en Alemania.",
        "Coordina el desarrollo, investigación y adopción del protocolo.",
        "Ha colaborado con gobiernos, empresas y organizaciones internacionales."
      ]
    },
    {
      heading: "Ventajas de IOTA",
      list: [
        "Transacciones sin comisiones.",
        "Alta escalabilidad teórica.",
        "Diseñada específicamente para IoT.",
        "Bajo requerimiento computacional.",
        "Arquitectura asincrónica y paralela."
      ]
    },
    {
      heading: "Desafíos y críticas",
      text: [
        "Historial de vulnerabilidades de seguridad.",
        "Dependencia temporal del Coordinador.",
        "Complejidad técnica elevada.",
        "Adopción más lenta que otras plataformas smart contract."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "IOTA representa una visión radicalmente distinta al modelo blockchain tradicional.",
        "Su enfoque en IoT, DAG y transacciones sin comisiones la hace única.",
        "Aunque ha enfrentado desafíos importantes, sigue siendo uno de los experimentos más ambiciosos en DLT.",
        "Entender IOTA es comprender cómo blockchain puede evolucionar más allá de las cadenas de bloques."
      ]
    }
  ]
};

export default CAP8;
